import React, { useCallback, useEffect, useState } from 'react';
import AppLoader from 'components/Loader';
import swal from 'sweetalert2';
import { useDispatch, useSelector } from 'react-redux';
import { addInfoItem } from 'redux/thunks/dashboard';
import { resetAddingInfoItem } from 'redux/actions/dashboard';
import { Button, Grid, TextField, Typography } from '@material-ui/core';
import Modal from 'components/ModalWrapper';
import './AddInfoModal.css';

const AddInfoModal = (props) => {
    const { info, onClose, show, siteId, dashboardId } = props;
    const [body, setBody] = useState('');
    const [title, setTitle] = useState('');
    const [fieldErrors, setFieldErrors] = useState({});
    const dispatch = useDispatch();
    const dashboard = useSelector((state) => state.dashboard);

    const displayErrorMessage = (text, title = 'Error!') => {
        swal.fire({
            title: title,
            type: 'error',
            text: text,
        });
    };

    const validate = () => {
        let errors = {};

        if (!title) {
            errors['title'] = '';
        }

        if (!body) {
            errors['body'] = '';
        }

        setFieldErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const handleClose = useCallback(() => {
        setBody('');
        setTitle('');
        setFieldErrors({});
        onClose();
    }, [onClose]);

    const handleSave = async () => {
        if (!validate()) {
            return;
        }
        const infoExists = info.some((info) => info.title === title);

        if (infoExists) {
            displayErrorMessage('Info with that title already exists');
            return;
        }
        const infoItem = {
            title: title,
            body: body,
            siteId: siteId,
            dashboardId: dashboardId,
        };

        dispatch(addInfoItem(infoItem));
    };

    useEffect(() => {
        if (dashboard.addingInfoItemSuccess) {
            dispatch(resetAddingInfoItem());
            handleClose();
        }
    }, [dashboard.addingInfoItemSuccess, dispatch, handleClose]);

    return (
        <div>
            <Modal height='small' open={show} onCloseClicked={handleClose}>
                <Grid container direction='column' className='add-info-modal'>
                    <Grid container item justifyContent='center' className='add-info-modal__title'>
                        <Typography variant='h5'>Add Info</Typography>
                    </Grid>

                    <Grid container direction='column' className='add-info-modal__body'>
                        {dashboard.addingInfoItem ? (
                            <AppLoader />
                        ) : (
                            <>
                                <TextField
                                    error={'title' in fieldErrors}
                                    helperText={'title' in fieldErrors && 'This field is required'}
                                    label='Title *'
                                    placeholder='Enter your info title'
                                    variant='outlined'
                                    value={title}
                                    onChange={(e) => setTitle(e.target.value)}
                                    className='add-info-modal__form-field'
                                />
                                <TextField
                                    rows={4}
                                    error={'body' in fieldErrors}
                                    helperText={'body' in fieldErrors && 'This field is required'}
                                    label='Body *'
                                    variant='outlined'
                                    placeholder='Enter your info body'
                                    className='add-info-modal__form-field'
                                    value={body}
                                    onChange={(e) => setBody(e.target.value)}
                                />
                            </>
                        )}
                    </Grid>

                    <Grid container justifyContent='space-between' className='add-info-modal__footer'>
                        <Button
                            color='default'
                            size='large'
                            variant='contained'
                            onClick={handleClose}
                            className='add-info-modal__footer-button--close'
                        >
                            Close
                        </Button>
                        <Button
                            color='primary'
                            size='large'
                            variant='contained'
                            disabled={dashboard.addingInfoItem}
                            className='add-info-modal__footer-button--save'
                            onClick={handleSave}
                        >
                            Save Changes
                        </Button>
                    </Grid>
                </Grid>
            </Modal>
        </div>
    );
};

export default AddInfoModal;
